<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PR3Gye/tc-custom/9781683508984.jpg?1700958076785" alt="This image is the cover for the book Forgive Process"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forgive Process
      </h1>
      <p class="bookDescription body article font2">
        <i>The Forgive Process</i> reveals a simple process to forgive the hurts and pains that hold people back. Life is full-contact. There are hurts and joys at every turn. But those hurts, when they are not released, hold people captive. The way through a hurt is forgiveness. Yet many people do not understand forgiveness. The misunderstandings and myths make it even more difficult—unless you have a simple process to work through. With Lee Baucom’s principles, forgiving is a simple, six-step process. Anyone can forgive, move forward, and find peace and healing.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee H. Baucom
      </h2>
      
      <p class="authorDescription body article">Lee Baucom is a Thriveologist, studying and teaching how to thrive in life. As a coach and consultant, Dr. Baucom helps individuals and organizations move beyond “survival mode” on the path to thriving. The author of several books, including Thrive Principles and The Immutable Laws of Living, Dr. Baucom is also the host of two podcasts. He is Co-Principal of Impact Coaching Academy and currently resides in Louisville, KY.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?95926bee